/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowBigDownDash = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M15 5H9" }],
    ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z" }]
  ]
];

export { ArrowBigDownDash as default };
//# sourceMappingURL=arrow-big-down-dash.js.map
